import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Authenticator, useAuthenticator } from '@aws-amplify/ui-react';
import { Anchor } from 'lucide-react';

export function LoginPage() {
  const { authStatus } = useAuthenticator(context => [context.authStatus]);
  const navigate = useNavigate();

  useEffect(() => {
    if (authStatus === 'authenticated') {
      navigate('/');
    }
  }, [authStatus, navigate]);

  return (
    <div className="grid min-h-screen lg:grid-cols-2">
      {/* Brand panel */}
      <div className="relative hidden flex-col justify-between overflow-hidden bg-sidebar p-10 text-sidebar-foreground lg:flex">
        <div
          className="pointer-events-none absolute inset-0 opacity-60"
          aria-hidden
          style={{
            background:
              'radial-gradient(60% 50% at 20% 20%, rgba(0,102,204,0.55) 0%, transparent 70%), radial-gradient(50% 45% at 85% 80%, rgba(0,166,147,0.45) 0%, transparent 70%)',
          }}
        />
        <div className="relative flex items-center gap-3">
          <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary shadow">
            <Anchor className="h-5 w-5 text-white" aria-hidden />
          </span>
          <span className="text-lg font-semibold">Vapor Admin</span>
        </div>
        <div className="relative max-w-md">
          <h2 className="text-3xl font-semibold leading-tight">Engagement content for the Vapor app</h2>
          <p className="mt-3 text-sidebar-muted">
            Write, schedule and publish the cards that ferry travellers see while they wait for a departure.
          </p>
        </div>
        <p className="relative text-xs text-sidebar-muted">© 2026 Vapor App</p>
      </div>

      {/* Sign-in panel */}
      <div className="flex items-center justify-center bg-background p-6">
        <div className="w-full max-w-sm">
          <div className="mb-6 flex items-center gap-3 lg:hidden">
            <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary shadow">
              <Anchor className="h-5 w-5 text-white" aria-hidden />
            </span>
            <span className="text-lg font-semibold">Vapor Admin</span>
          </div>
          <div className="rounded-lg border border-border bg-card p-2 shadow-card">
            <Authenticator
              hideSignUp={true}
              components={{
                Header() {
                  return (
                    <div className="px-6 pb-2 pt-6">
                      <h1 className="text-xl font-semibold text-card-foreground">Sign in</h1>
                      <p className="mt-1 text-sm text-muted-foreground">Use your administrator account.</p>
                    </div>
                  );
                },
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
